'use strict';

module.exports = function (Member, LoopBackAuth, Department, myDepartments, myTenant, $q, $stateParams) {
    var user;
    var docToken;
    this.user;
    this.docToken;
    return {
        loadRoles: function () {
            return Member.roles()
                .$promise
                .then(function (roles) {
                    window.localStorage.$USER_ROLE = JSON.stringify(roles.roles);
                    return roles;
                });
        },
        loadDepartments: function (reload = false) {
            function _loadDepts(departments) {
                if (!departments.filter(d => d.subscription != true).length > 0 && !_this.isAuthorized('admin')) {
                    window.localStorage.$USER_ROLE = '["viewer"]';
                   /*  if (!departments.length)
                        return defer.reject('El usuario no es Admin, ni es dueño del tenant ni supervisa departamentos, ni tiene formularios subscriptos'); */
                }

                return defer.resolve(departments);               
            }

            var defer = $q.defer();
            var _this = this;
            let departments = myDepartments.get();
            // console.log('llamado 2 myDepartments.get()')
            // console.log("authFactory.loadDepartments");
            if(departments && !reload)
                _loadDepts(departments);
            else
                myDepartments.load().then(_loadDepts);
            return defer.promise;
        },
        login: function (credentials, onProgress) {
            var _this = this;
            var report = function (step) {
                if (typeof onProgress === 'function') {
                    onProgress(step);
                }
            };
            report('LOGIN.PROGRESS.LOADING_PROFILE');
            return Member.login(credentials)
                .$promise
                .then(function (_user) {
                    if (_user && _user.hasOwnProperty('user')) {
                        user = _user.user;
                        if (_user.hasOwnProperty('docToken')) {
                            docToken = _user.docToken;
                            _this.docToken = docToken;
                        }
                    } else {
                        user = _user;
                    }
                    _this.user = user;
                    report('LOGIN.PROGRESS.VERIFYING_PERMISSIONS');
                    return _this.loadRoles();
                })
                .then(function (_roles) {
                    user.roles = _roles;
                    report('LOGIN.PROGRESS.LOADING_CONFIG');
                    return Member.prototype$__get__tags({ "id": user.id})
                    .$promise
                    .then(
                        function (_tags) {
                            user.tags = _tags
                            return _tags;
                        }
                    )
                })
                .then(function () {
                    report('LOGIN.PROGRESS.LOADING_DEPARTMENTS');
                    return _this.loadDepartments();
                });
        },
        logOut: function () {
            user = null;
            docToken = null;
            this.user = null;
            this.docToken = null;
            myDepartments.set(undefined);
            if (Member.isAuthenticated()) {
                delete window.localStorage.$USER_ROLE;
                delete window.localStorage.$LoopBack$currentUserId;
                delete window.localStorage.$LoopBack$accessTokenId;
                delete window.localStorage.$LoopBack$rememberMe;

                return Member.logout({}, {})
                    .$promise;
            }

            return $q.resolve();
        },
        currentUserInfo: function () {
            return this.user
        },
        currentDocToken: function () {
            return this.docToken;
        },
        getAccessToken: function () {
            return window.localStorage.$LoopBack$accessTokenId || LoopBackAuth.accessTokenId;
        },
        currentUser: function(){
            return window.localStorage.$LoopBack$currentUserId;
        }
        ,
        isOnlyViewerInDept: function (deptId) {
            deptId = deptId || $stateParams.departmentId;
            let isAdmin=false;
            try{
                isAdmin = window.localStorage.$USER_ROLE.toLowerCase().includes("admin")
                if (isAdmin)
                    return false;
            }catch(e){}
            const departments = myDepartments.get("myDepartments");
            // console.log('llamado 3 myDepartments.get("myDeparments")')
            try{
                const dept = departments.find(d => (deptId == undefined || d.id == deptId));             
                const isAssignAsOwner = (dept.owners && dept.owners.find(o => o.id == window.localStorage.$LoopBack$currentUserId) != undefined);
                if(isAssignAsOwner)
                    return false;
                const isSiteAdmin = dept.client && dept.client.owners && dept.client.owners.find(o => o.id == window.localStorage.$LoopBack$currentUserId)                
                return isSiteAdmin == undefined;
            }catch(e){console.log("isOnlyViewerInDept",e)}
            
        }
        ,
        isAuthorized: function (neededRoles) {
            neededRoles = [].concat(neededRoles);
            if (!window.localStorage.$USER_ROLE) {
                return false;
            }

            var userRoles = []; //JSON.parse(window.localStorage.$USER_ROLE);
            try {
                userRoles = JSON.parse(window.localStorage.$USER_ROLE);
            } catch (e) {
                userRoles = window.localStorage.$USER_ROLE.split(",")
                window.localStorage.$USER_ROLE = JSON.stringify(userRoles);
            }
            userRoles.push("mobileUser");
            
            if (!userRoles) {
                this.logOut();
            }
            if (userRoles.indexOf('supervisor') == -1 && userRoles.indexOf('viewer') == -1 && userRoles.indexOf('admin') == -1)
                userRoles.push("owner");
            return neededRoles.some(function (neededRole) {
                return userRoles.indexOf(neededRole) > -1;
            });
        },
        resolveUser: function (reload) { // Reload for validations
            var _this = this;
            if (!reload && this.user)
                return new Promise((res)=>res(this.user));
            return Member.getCurrent({
                filter: {
                    include: ['tenant','tags']
                }
            })
            .$promise
            .then(function (currentUser) {
                user = currentUser;
                _this.user = user;

                _this.docToken = currentUser.tenant.docToken;

                if (user.hasOwnProperty('tenant') && user.tenant.hasOwnProperty('docToken')) {
                    docToken = user.tenant.docToken;
                    _this.docToken = docToken;
                }
                return user;
            });
        }
    };
};
